module.exports = __webpack_public_path__ + "static/media/responsive-1.095e0ec7.svg";